<template>
  <div class="zz-header">
    <div style="padding-left: 25px">
      <a :href="home_url">
        <img src="//n.sinaimg.cn/default/db05cb32/20180706/logo.png" width="200" />
      </a>
    </div>
    <div style="margin-right: 30px;display:flex;align-items:center">
      <span style="padding-right: 20px;font-size: 14px;color: #35495e;">{{ user_name }}</span>
      <el-dropdown @command="dc">
        <img :src="avatar" width="36" style="border-radius:36px" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in dropOptions" :command="item.id" :key="item.id">{{ item.text
            }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <w-header
      :drop-options="dropOptions"
      :home-url="home_url"
      @drop-click="dc"
      logoSrc="//n.sinaimg.cn/default/db05cb32/20180706/logo.png"
      :username="user_name"
      :avatarSrc="avatar"
      v-bind:logoWidth="200"
    ></w-header> -->
  </div>
</template>
<script>
/* eslint-disable */
import { getData } from "../utils/utils";
import axios from "axios";
import qs from "qs";
export default {
  name: "Header",
  components: {},
  data: function () {
    return {
      dropOptions: [
        {
          id: "logout",
          text: "退出",
        },
      ],
      avatar: "",
      user_name: "",
      home_url: "",
      localStorageKey: "",
    };
  },
  mounted: function () {
    let params = {};
    this.home_url = "/";
    if (!location.host.includes("brand")) {
      let user = window.sso_weiboad.getSinaCookie(true);
      if (user && user.uid) {
        this.localStorageKey = "weibo_user_info_" + user.uid;
      }
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
        this.localStorageKey =
          "weibo_user_info_" + this.$route.query["customer_id"];
      }
      this.home_url =
        Object.keys(params).length > 0 ? `/?${qs.stringify(params)}` : "/";
      let userData = JSON.parse(
        window.localStorage.getItem(this.localStorageKey) || null
      );
      if (
        userData &&
        userData.hasOwnProperty("data") &&
        userData.data &&
        userData.data.hasOwnProperty("username")
      ) {
        this.avatar = userData.data.avatar;
        this.user_name = userData.data.username;
        //matomo统计
        _paq.push(["setUserId", this.user_name || ""]);
        _paq.push(["trackPageView"]);
        _paq.push(["enableLinkTracking"]);
      } else {
        let now = new Date().getTime();
        // 获取用户数据并存储到本地
        getData("/api/userinfo/get", params, (res) => {
          if (res.code != 0) {
            this.$message.warning(res.msg);
            setTimeout(() => {
              window.location.href = "/";
            }, 500);
          } else {
            res.data.avatar = "//" + res.data.avatar.split("://")[1];
            userData = {
              data: res.data,
              expired: now + 24 * 3600 * 1000,
            };
            if (userData.data.hasOwnProperty("username")) {
              this.avatar = userData.data.avatar;
              this.user_name = userData.data.username;
              //matomo统计
              _paq.push(["setUserId", this.user_name || ""]);
              _paq.push(["trackPageView"]);
              _paq.push(["enableLinkTracking"]);
              if (
                this.$route.query["customer_id"] &&
                this.$route.query["customer_id"] !== userData.data.uid
              ) {
                this.localStorageKey = "weibo_user_info_" + userData.data.uid;
              }
              window.localStorage.setItem(
                this.localStorageKey,
                JSON.stringify(userData)
              );
            } else if (process.env.NODE_ENV !== "development") {
              if (this.$route.query["clientId"]) {
                window.location.href =
                  "//weibo.com/login.php?url=" +
                  encodeURIComponent(window.location.href);
              }
            }
          }
        });
      }
    } else {
      if (this.$route.query["loginParam"]) {
        let params = {};
        params["loginParam"] = this.$route.query["loginParam"];
        this.home_url =
          Object.keys(params).length > 0 ? `/?${qs.stringify(params)}` : "/";
        // 获取当前登陆人信息
        getData("/api/brand/login", this.$route.query, (res) => {
          this.user_name = JSON.parse(res.data).name;
          this.avatar = require("../assets/person.png");
        });
      }
    }
  },
  methods: {
    dc: function (command) {
      if (command == "logout") {
        // let user = window.sso_weiboad.getSinaCookie(true)
        // let localStorageKey = 'weibo_user_info_' + user.uid
        // window.sso_weiboad.logout()
        if (this.$route.query["loginParam"]) {
          // axios.get("/api/brand/logout?loginParam=" + this.$route.query["loginParam"]);
          const aLink = document.createElement("a");
          document.body.appendChild(aLink);
          //设置a标签不可见
          aLink.style.display = "none";
          //设置a标签的下载链接
          aLink.href =
            "/api/brand/logout?loginParam=" + this.$route.query["loginParam"];
          //模拟点击事件下载
          aLink.click();
          //移除页面a链接
          document.body.removeChild(aLink);
        } else {
          axios.get("/api/userinfo/logout");
          //Matomo 登出清理用户状态
          // _paq.push(["resetUserId"]);
          // _paq.push(["trackPageView"]);
          window.localStorage.removeItem(this.localStorageKey);
          window.location.href = "https://weibo.com/";
        }
      }
    },
  },
};
</script>
<style>
.zz-header {
  padding: 10px 0 10px 0;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.zz-header div {
  -webkit-box-shadow: inset 0 0 0 0 #e1e6f1;
  box-shadow: inset 0 0 0 0 #e1e6f1;
}

.zz-header a {
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue